import { useMemo, useState } from "react";
import { VoiceAgentVoiceFiltersProps } from "../components/VoiceAgentVoiceFilters";
import { VoiceAgentVoicePickerProps } from "../VoiceAgentVoicePicker";
import { VoiceFilterValue, VoiceGender, VoiceStyle } from "../types";

interface UseVoiceFiltersReturn {
  filtersProps: Omit<VoiceAgentVoiceFiltersProps, "isDisabled">;
  pickerProps: Pick<VoiceAgentVoicePickerProps, "gender" | "style">;
}

/**
 * Keeps the gender/style filter state for screens that render
 * `VoiceAgentVoiceFilters` and `VoiceAgentVoicePicker` in separate layout slots
 */
export const useVoiceFilters = (): UseVoiceFiltersReturn => {
  const [gender, setGender] = useState<VoiceFilterValue<VoiceGender>>("all");
  const [style, setStyle] = useState<VoiceFilterValue<VoiceStyle>>("all");

  return useMemo(
    () => ({
      filtersProps: {
        gender,
        style,
        onGenderChange: setGender,
        onStyleChange: setStyle,
      },
      pickerProps: { gender, style },
    }),
    [gender, style]
  );
};
